import React from 'react';
import { Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export default function ItemOrBundleSelect ({ open, onClose, onSingleClick = null, onBundleClick = null }) {

    const handleClose = () => onClose();

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
          <DialogTitle>
            Add Item(s)
          </DialogTitle>
          <DialogContent>
            <Stack spacing={1}>
              <Button variant='outlined' onClick={onSingleClick}>Single Item</Button>
              <Button variant='outlined' onClick={onBundleClick}>Bundle</Button>
            </Stack>
          </DialogContent>
          <DialogActions>
            <div style={{flex: '1 0 0'}} />
            <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}